import React, { type FC } from 'react';

import Avatar from '@atlaskit/avatar';
import { Inline, Text } from '@atlaskit/primitives/compiled';

import { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';

/**
 * Data structure for user information in content state updates.
 * Used by UserUpdateInfo component and ContentStateInfoPopup.
 * This is the canonical shape for user metadata in content state contexts.
 */
export type UserUpdateInfoData = {
	displayName: string;
	avatarUrl?: string;
	userId: string;
};

type UserUpdateInfoProps = UserUpdateInfoData;

/**
 * Displays user avatar and name for the content state update metadata.
 * Wraps with ProfileCardWrapper to show profile card on hover.
 * Handles spacing and padding around the avatar.
 *
 * @param displayName - User's display name (required)
 * @param avatarUrl - Optional URL of user's avatar image
 * @param userId - Confluence account ID for profile card hover feature (required)
 */
export const UserUpdateInfo: FC<UserUpdateInfoProps> = ({ avatarUrl, displayName, userId }) => (
	<ProfileCardWrapper userId={userId}>
		<Inline space="space.050" alignBlock="center">
			<Avatar src={avatarUrl} name={displayName} size="xsmall" />
			<Text size="small">{displayName}</Text>
		</Inline>
	</ProfileCardWrapper>
);
